export default {
  loggedHome: '/packagesBySearchCode',
  profile: '/profile',
  inbox: '/inbox',
  packet: {
    entry: '/entryPacket',
    departure: {
      paquer: '/paquerDeparture',
      paqueryPoint: '/paqueryPointDeparture',
      logisticOperator: '/oplDeparture',
      history: '/packages/departure/history',
    },
    deliver: '/deliverPickup',
  },
  packages: {
    bySearchCode: '/packagesBySearchCode',
    byId: '/packages/id/:id',
    byExternalCode: '/packages/:externalCode',
    history: '/packages/history',
    list: '/packages',
    view: '/packages/view/:id',
    withoutZone: '/packages/withoutZone',
    withPaquers: '/packages/byPaquer',
    withPaquersHistorical: '/packages/byPaquer/history',
    send: '/packages/send',
  },
  massive: {
    list: '/massive',
  },
  journey: '/journey',
  journeys: '/journeys',
  // La seccion de rutas es un submenu, como Paquetes y Colectas: las tres
  // listas y los dos altas, una por tipo de ruta.
  journeysTracking: '/journeys/active',
  journeysPrep: '/journeys/draft',
  journeysHistory: '/journeys/history',
  journeysNewShipments: '/journeys/new/shipments',
  journeysNewCollections: '/journeys/new/collections',
  journeysTemplates: '/journeys/templates',
  routes: {
    list: '/routes',
    create: '/routes/create',
    history: '/routes/history',
    view: '/routes/view/:id',
  },
  paquers: {
    list: '/paquers',
    view: '/paquers/:paquerId',
    add: '/paquers/add',
  },
  collections: {
    // requests es el listado del modulo viejo y no se mueve: las colectas en
    // curso al momento del corte se siguen mirando y cancelando ahi.
    requests: '/colectas/solicitudes',
    intake: '/colectas/ingreso',
    points: '/colectas/puntos',
    // Como Paquetes: lo vivo en una vista, lo terminado en otra.
    transit: '/colectas/en-transito',
    history: '/colectas/historico',
  },
  support: {
    index: '/support',
  },
  messaging: {
    outbound: '/messaging/outbound',
  },
  // --- Administración (portado de webapp-opl) ---
  users: {
    list: '/users',
    add: '/users/add',
    edit: '/users/:id',
  },
  paquerypoint: {
    list: '/paquerypoints',
    add: '/paquerypoints/add',
    edit: '/paquerypoints/:paquerypointId',
  },
  marketplace: {
    list: '/marketplaces',
    add: '/marketplaces/add',
    edit: '/marketplaces/:marketplaceId',
  },
  store: {
    add: '/marketplaces/:marketplaceId/stores/add',
    edit: '/marketplaces/:marketplaceId/stores/:storeId',
  },
  zones: {
    list: '/zones',
    add: '/zones/add',
    edit: {
      route: '/zones/edit/:id',
      forId: '/zones/edit',
    },
    grouping: {
      add: '/zones/grouping/add',
      edit: '/zones/grouping/edit',
      route: '/zones/grouping/edit/:id',
    },
  },
  rates: {
    list: '/rates',
    lastMile: '/rates/lastMile',
    interUrban: '/rates/interUrban',
  },
  assignee: {
    routes: '/assignee/routes',
    drivers: '/assignee/drivers',
  },
};
